import { Box, Center, For, Stack, Image } from '@chakra-ui/react';
import { size } from 'lodash';
import { Drawer } from '@halo/ui-react';
import { CloseIcon } from '@halo/ui-chat-react';
import { useActionsStore } from '@/store/actions';
import { Header } from './Profile/Header';
import { useRobotInfo } from './Helper';

export const RobotProfileDialog = memo(function RobotProfileDialog() {
  const { t } = useTranslation();
  const { profileRobotIsOpen, profileRobot, setProfileRobotIsOpen } = useActionsStore();
  const robotMemo = useRobotInfo(profileRobot);
  return (
    <>
      <Drawer.Root
        open={profileRobotIsOpen}
        onOpenChange={(details) => setProfileRobotIsOpen(details.open)}
      >
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content w="560px" maxW="100%">
            <Drawer.Header
              className="Header"
              pt="5"
              px="5"
              pb="2.5"
              justifyContent="space-between"
            >
              <Drawer.Title fontSize="md" fontWeight="semibold">
                {t('profile.profileTitle')}
              </Drawer.Title>
              <Center cursor="pointer" onClick={() => setProfileRobotIsOpen(false)}>
                <CloseIcon />
              </Center>
            </Drawer.Header>
            <Drawer.Body className="scrollHover" p={0} bg="bg.subtle">
              <Image className="Box" w="full" src={robotMemo?.bg} h="300px"></Image>
              <Header
                user={profileRobot}
                bio={robotMemo?.bio}
                tooltip={robotMemo?.tooltip}
                official={robotMemo?.isofficial}
              />
              {size(robotMemo?.permission) > 0 && (
                <Stack px="5">
                  <Box
                    fontWeight="medium"
                    color="fg"
                    borderTop="1px solid"
                    borderColor="border.muted"
                    pt="3"
                  >
                    {t('profile.bot_statement')}
                  </Box>
                  <For each={robotMemo.permission}>
                    {(item, index) => (
                      <Box
                        key={index}
                        color="fg.muted"
                        pos="relative"
                        ml="3"
                        pl="3"
                        _before={{
                          content: '""',
                          w: '4px',
                          h: '4px',
                          borderRadius: 'full',
                          pos: 'absolute',
                          top: 0,
                          bottom: 0,
                          left: 0,
                          margin: 'auto',
                          bg: 'fg.muted',
                        }}
                      >
                        {item}
                      </Box>
                    )}
                  </For>
                </Stack>
              )}
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Drawer.Root>
    </>
  );
});
